import PropTypes from 'prop-types';

const PropTypeLinkModel = PropTypes.shape({
  Type: PropTypes.string,
  Uri: PropTypes.string,
  TextItems: PropTypes.arrayOf(PropTypes.string),
  RichTextItems: PropTypes.arrayOf(PropTypes.shape({})),
});
const PropTypeImageModel = PropTypes.shape({
  Type: PropTypes.string,
  Uri: PropTypes.string,
});
const PropTypeTextModel = PropTypes.shape({
  Type: PropTypes.string,
  Class: PropTypes.string,
  TextValue: PropTypes.string,
});
const PropTypeVoidModel = PropTypes.shape({ Type: PropTypes.string });

const PropTypeRichTextItem = PropTypes.oneOfType([
  PropTypeLinkModel,
  PropTypeImageModel,
  PropTypeTextModel,
  PropTypeVoidModel,
]);
export const PropTypeRichTextItems = PropTypes.arrayOf(PropTypeRichTextItem);

const PropTypeModel = PropTypes.shape({
  LocalizationKey: PropTypes.string,
  RichTextItems: PropTypeRichTextItems,
  IsReadonly: PropTypes.bool,
  Id: PropTypes.string,
  Selected: PropTypes.bool,
});

export const PropTypeModels = PropTypes.arrayOf(PropTypeModel);
